import { Pipe, PipeTransform } from '@angular/core';

export type FormatArrayType = 'string' | 'number';

@Pipe({ name: 'formatArray' })
/**
 * Formats an Array to a string
 */
export class FormatArrayPipe implements PipeTransform {
  transform(array: any[], type: FormatArrayType): string {
    if (!array || array.length === 0 || !type) {
      return '';
    }
    if (type === 'string' || type === 'number') {
      return array.join(', ');
    }
  }
}
